import { Component, OnInit } from '@angular/core';
import { VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-team',
  templateUrl: './team.component.html',
  styleUrls: ['./team.component.scss']
})
export class TeamComponent implements OnInit {

  constructor(
    public variablesService: VariablesService
  ) { }

  ngOnInit() {
    this.variablesService.mainLayoutConfig.next({
      showHeader: true, showFooter: true, showMenus: true, showProfile: true, showSearch: true,
      logoNavigate: true, animateHeader: true, showCurrency: false, headerClass: 'homepage-header',
      headerTopSticky: true
    });
  }

}
